module.exports = __webpack_public_path__ + "img/bg-window.54dced1d.png";